import { Grid } from "@material-ui/core";
import React from "react";
import AccordionNav from "../../components/common/AccordionNav";
import { useTranslation } from "../../hooks/useTranslation";
import CriminalRecords from "./CriminalRecords/CriminalRecords";
import PersonalAccidents from "./PersonalAccidents/PersonalAccidents";
import ProviderDetails from "./ProviderDetails/ProviderDetails";

const Providers = () => {
  const { t, BundleKey } = useTranslation();
  return (
    <AccordionNav title={t(BundleKey.DETAIL_PROVIDER_TITLE)} expanded={true}>
      <Grid container spacing={3} direction="row">
        <Grid item xs={12} sm={6}>
          <ProviderDetails />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <PersonalAccidents />
            </Grid>
            <Grid item xs={12}>
              <CriminalRecords />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </AccordionNav>
  );
};

export default Providers;
